import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import eventsData from "../data/events.json";

function formatDate(dateString) {
  const [day, month, year] = dateString.split("-");
  const date = new Date(`${year}-${month}-${day}`);

  const months = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  if(months[date.getMonth()]===undefined){
    return `${day} ${"?"} ${year}`;
  }

  return `${day} ${months[date.getMonth()]} ${year}`;
}

function CategoryTable({ title, id, data }) {
  if (!data || data.length === 0) return null; 

  return (
    <div className="category-wrapper separator-down">
      <table>
        <caption className="category">{title}</caption>
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Fecha</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td className="name">{item.title}</td>
              <td className="date">{formatDate(item.date)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function Proyects() {
  const editions = eventsData.edition;
  const semiEditions = eventsData.semiEdition;
  const others = eventsData.other;
  const contests = eventsData.contest;
  const tournaments = eventsData.tournament;
  const events = eventsData.event;

  return (
  <>
   <HelmetProvider>
      <Helmet>
        <title>Eventos | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="events"  className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Eventos</h1>
          <p className="subtitle">Aquí está el historial de todos los eventos que hemos realizado a lo largo de estos años.</p>
        </div>
        <div className="content-main">
          <CategoryTable title="Ediciones" id="edition" data={editions} />
          <CategoryTable title="Semi-Ediciones" id="semiedition" data={semiEditions} />
          <CategoryTable title="Otros eventos" id="other" data={others} />
          <CategoryTable title="Concursos" id="contest" data={contests} />
          <CategoryTable title="Torneos" id="tournament" data={tournaments} />
          <CategoryTable title="Eventos" id="event" data={events} />
        </div>
      </div>
    </div>
  </>
  );
}
